import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzfi = () => {
    return (
        <div>
                <NavLink to='/category/Puzzels/Puzzel6'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel4'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-Previous page  </Button>
</NavLink>
<article className='container'>
    <section class="es et eu ev aj ew dd s"></section><span class="s"></span>
    <div>
        <div class="t v up fe ff fg"></div>
        <section class="fh fi fj fk fl">
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <div class="">
                        <h1 id="7c16"
                            class="fn fo fp fq b fr fs ft fu fv fw fx fy fz ga gb gc gd ge gf gg gh gi gj gk gl bx">A
                            King, 1000 Bottles of Wine, 10 Prisoners and a Drop of Poison</h1>
                    </div>
                    <div class="">
                        <h2 id="d76c" class="gm fo fp as b gn go gp gq gr gs gt gu gv gw gx gy gz ha hb hc av">a
                            mathematical riddle</h2>
                        </div>

                        </div>
                    </div>
                    <p id="729a"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph=""><em class="jm">Ready for the solution?</em></p>
                  
                    <blockquote class="jo jp jq">
                        <p id="4453"
                            class="iq ir jm is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                            data-selectable-paragraph="">The King of a small country invites 1000 senators to his annual
                            party. As a tradition, each senator brings the King a bottle of wine. Soon after, the Queen
                            discovers that one of the senators is trying to assassinate the King by giving him a bottle
                            of poisoned wine. Unfortunately, they do not know which senator, nor which bottle of wine is
                            poisoned, and the poison is completely indiscernible. However, the King has 10 prisoners he
                            plans to execute. He decides to use them as taste testers to determine which bottle of wine
                            contains the poison. The poison when taken has no effect on the prisoner until exactly 24
                            hours later when the infected prisoner suddenly dies. The King needs to determine which
                            bottle of wine is poisoned by tomorrow so that the festivities can continue as planned.
                            Hence he only has time for one round of testing. How can the King administer the wine to the
                            prisoners to ensure that 24 hours from now he is guaranteed to have found the poisoned wine
                            bottle?</p>
                    </blockquote>
                    <p id="508b"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Don’t worry if you weren’t able to solve it. The important part is
                        to try.</p>
                   
             
           
        </section>
        <div class="n p hd jr js jt" role="separator"><span class="ju df bq jv jw jx"></span><span
                class="ju df bq jv jw jx"></span><span class="ju df bq jv jw"></span></div>
        <section class="fh fi fj fk fl">
            <div class="jy">
               
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <h1 id="5ed7"
                        class="kt ku fp as kv kw kx iu ky kz la ix lb lc ld le lf lg lh li lj lk ll lm ln lo bx"
                        data-selectable-paragraph=""><strong class="bc"><em class="lp">possible solution
                                one:</em></strong></h1>
                    <p id="4b5b"
                        class="iq ir fp is b gn lq iu iv gq lr ix iy iz ls jb jc jd lt jf jg jh lu jj jk jl fh bx"
                        data-selectable-paragraph="">Let’s start by restating the problem.</p>
                    <p id="f17a"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">We have <strong class="is lv">1000 bottles of wine</strong>,
                        <strong class="is lv">one of which is poisoned</strong> and somehow we need to test all of the
                        wine bottles using only 10 prisoners as taste testers. However we decide to administer the wine
                        to the prisoners, we need to use the prisoners deaths as a code to trace back to the poisoned
                        wine bottle.</p>
                    <p id="b2a5"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Since we have only 24 hours to test the wine, we know that there is
                        not enough time nor enough prisoners to test the wine one-by-one. I’m guessing you got to this
                        point and that’s where the confusion set in.</p>
                    <p id="11f8"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph=""><em class="jm">How can we test all of the bottles?</em> Well, we’re
                        going to have to get the prisoners drunk, I can tell you that much! Jk, but seriously we need to
                        systematically distribute the wine to the prisoners so that there are <strong class="is lv"><em
                                class="jm">at least a thousand different combinations!</em></strong></p>
                    <p id="1670"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">First, let’s line up our 10 prisoners and label them. Also label
                        the wine bottles 0–999 so we can tell them apart.</p>
                </div>
            </div>
            <div class="jy">
                <div class="n p">
                    <div class="jz ka kb kc kd ke af kf ag kg ai aj">
                        <figure class="kh ki kj kk kl jy lx ly paragraph-image">
                            <div role="button" tabindex="0" class="lz ma bz mb aj mc">
                                <div class="eu ev lw"><img alt="" class="aj md me"
                                        src="https://miro.medium.com/max/2692/1*qtxvAgyDVkwwbDSY8h1Sbg.png" width="1346"
                                        height="151" role="presentation"/></div>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="8425"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Let’s have Prisoner A drink from every other bottle starting with
                        the first bottle, bottle #0. In other words, Prisoner A will drink from bottles 0, 2, 4, …</p>
                </div>
            </div>
           
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="cc1e"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Next, assign Prisoner B the task of drinking from every other set
                        of two bottles. For example, Prisoner B drinks from bottles 0 and 1, skips 2 and 3. Drinks from
                        4 and 5, skips 6 and 7, and so forth continuing the pattern.</p>
                </div>
            </div>
            
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="a159"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Have Prisoner C drink from every other set of four bottles: i.e.
                        Prisoner C drinks from bottles 0–3, (skip 4–7), 8–11, (skip 12–15), 16–19, …</p>
                </div>
            </div>
            
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="43bd"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph=""><em class="jm">Are you seeing the pattern? </em>Keep doubling the
                        number of bottles each prisoner drinks in succession.</p>
                    <p id="d941"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Prisoner D drinks from every other set of eight bottles. Prisoner E
                        from every other set of 16. Prisoner F from every other 32. Prisoner G from every other 64.
                        Prisoner H from every other 128. Prisoner I from every other 256. And lastly, Prisoner J from
                        the first 512 bottles.</p>
                </div>
            </div>
            
          
                <div class="ab ac ae af ag fm ai aj">
                    <p id="59e1"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">At this point, you may notice something looks familiar. <strong
                            class="is lv">The bottle assignments reflect powers of 2.</strong></p>
                </div>
            </div>
            
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="e378"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">We have successfully distributed the wine so that there are
                        sufficiently many combinations. Now we wait 24 hours to see which prisoners were poisoned.</p>
                    <p id="6507"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph=""><em class="jm">How will we be able to tell which bottle was the
                            poisonous one?</em> We will look at the pattern of poisoned prisoners encoded in <a
                            class="cd jn" rel="noopener" href="/i-math/decoding-binary-numbers-50b8fd914908">binary</a>.
                        To do so I’ll place a <strong class="is lv">zero above the prisoners who are poisoned</strong>,
                        and a <strong class="is lv">one above those who aren’t.</strong></p>
                    <p id="d121"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Before we decode the result, we need to flip our prisoners around
                        so that it matches the binary place-value system.</p>
                </div>
            </div>
            <div class="jy">
                <div class="n p">
                    <div class="jz ka kb kc kd ke af kf ag kg ai aj">
                        <figure class="kh ki kj kk kl jy lx ly paragraph-image">
                            <div role="button" tabindex="0" class="lz ma bz mb aj mc">
                                <div class="eu ev mk"><img alt="" class="aj md me"
                                        src="https://miro.medium.com/max/2672/1*PBIsnA-yRsI9LDA0zaXy3Q.png" width="1336"
                                        height="205" role="presentation"/></div>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="77a4"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">There we go. Now suppose all the prisoners are poisoned? Which
                        bottle of wine was it?</p>
                    <p id="cf4c"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Well it must have been the first bottle, bottle #0, since this is
                        the only bottle that they all drank from.</p>
                    <p id="5b16"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">This is confirmed in our diagram because if they are all poisoned,
                        we place a zero above every prisoner. And 0000000000 in binary is still 0 in decimal.</p>
                </div>
            </div>
            <div class="jy">
                <div class="n p">
                    <div class="jz ka kb kc kd ke af kf ag kg ai aj">
                        <figure class="kh ki kj kk kl jy lx ly paragraph-image">
                            <div role="button" tabindex="0" class="lz ma bz mb aj mc">
                                <div class="eu ev ml"><img alt="" class="aj md me"
                                        src="https://miro.medium.com/max/2684/1*weM2dobnWAPPkheD2Yj1rA.png" width="1342"
                                        height="214" role="presentation"/></div>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="fbda"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Now let’s suppose that everyone <em class="jm">except</em> prisoner
                        A is poisoned.</p>
                </div>
            </div>
            <div class="jy">
                <div class="n p">
                    <div class="jz ka kb kc kd ke af kf ag kg ai aj">
                        <figure class="kh ki kj kk kl jy lx ly paragraph-image">
                            <div role="button" tabindex="0" class="lz ma bz mb aj mc">
                                <div class="eu ev mm"><img alt="" class="aj md me"
                                        src="https://miro.medium.com/max/2690/1*dbwW2ofTj7y-rzcNCvEM6Q.png" width="1345"
                                        height="304" role="presentation"/></div>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="3e4e"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">If we translate 0000000001 into decimal we get 1. Which means
                        bottle # 1 was poisoned. This confirms what we know to be true because Prisoner A was the only
                        prisoner <em class="jm">not</em> to drink from bottle # 1 (remember Prisoner A drank from
                        bottles 0, 2, 4, 6…).</p>
                    <p id="c662"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">How about if prisoners J, H, F, D and B are poisoned?</p>
                </div>
            </div>
            <div class="jy">
                <div class="n p">
                    <div class="jz ka kb kc kd ke af kf ag kg ai aj">
                        <figure class="kh ki kj kk kl jy lx ly paragraph-image">
                            <div role="button" tabindex="0" class="lz ma bz mb aj mc">
                                <div class="eu ev mn"><img alt="" class="aj md me"
                                        src="https://miro.medium.com/max/2660/1*Ca44vXx8LgR0_WhsdhQb4g.png" width="1330"
                                        height="316" role="presentation"/></div>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="b7c0"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Translate the number 0101010101 into decimal to determine which
                        bottle it was.</p>
                    <p id="bb0a"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">101010101 = 256 + 64 + 16 + 4 + 1 = 341.</p>
                    <p id="242a"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Hence, bottle number 341 was the poisonous bottle.</p>
                    <p id="09d8"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph=""><em class="jm">Pretty clever, isn’t it?</em> Because there are 10
                        prisoners and each prisoner has two states (dead or alive), this system has a grand total of
                        1,024 different combinations.</p>
                    <figure class="kh ki kj kk kl jy eu ev paragraph-image">
                        <div role="button" tabindex="0" class="lz ma bz mb aj mc">
                            <div class="eu ev mo"><img alt="" class="aj md me"
                                    src="https://miro.medium.com/max/548/1*Nhsb-qaQuRszgtUGwareag.png" width="274"
                                    height="106" role="presentation"/></div>
                        </div>
                    </figure>
                    <p id="b0cc"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">This is more than enough combinations since we only have 1000
                        bottles.</p>
                    <h1 id="248e"
                        class="kt ku fp as kv kw kx iu ky kz la ix lb lc ld le lf lg lh li lj lk ll lm ln lo bx"
                        data-selectable-paragraph=""><strong class="bc"><em class="lp">possible solution
                                two:</em></strong></h1>
                    <p id="cf86"
                        class="iq ir fp is b gn lq iu iv gq lr ix iy iz ls jb jc jd lt jf jg jh lu jj jk jl fh bx"
                        data-selectable-paragraph="">This solution jumps straight into binary.</p>
                    <p id="3d46"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">To begin, <strong class="is lv">label each bottle with both its
                            decimal number and binary equivalent.</strong></p>
                   
                    <p id="3cc5"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Now each bottle serves as a code describing which prisoners are to
                        drink from it. In this system, a <strong class="is lv">one means the prisoner drinks</strong>
                        from it, a <strong class="is lv">zero means the prisoner doesn’t.</strong></p>
                </div>
            </div>
            <div class="jy">
                <div class="n p">
                    <div class="jz ka kb kc kd ke af kf ag kg ai aj">
                        <figure class="kh ki kj kk kl jy lx ly paragraph-image">
                            <div role="button" tabindex="0" class="lz ma bz mb aj mc">
                                <div class="eu ev lw"><img alt="" class="aj md me"
                                        src="https://miro.medium.com/max/2692/1*qtxvAgyDVkwwbDSY8h1Sbg.png" width="1346"
                                        height="151" role="presentation"/></div>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="n p">
                <div class="ab ac ae af ag fm ai aj">
                    <p id="00b6"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">For example, only Prisoner J should drink from bottle one since its
                        binary is 0000000001. Whereas, Prisoners I and G should drink from bottle ten whose binary is
                        0000001010 because it has 1's in the columns that match up with prisoners I and G.</p>
                    <p id="e274"
                        class="iq ir fp is b gn it iu iv gq iw ix iy iz ja jb jc jd je jf jg jh ji jj jk jl fh bx"
                        data-selectable-paragraph="">Continue this process until you have given out sips of wine from
                        every bottle. After 24 hours, line up the prisoners in order and note which ones have been
                        poisoned with ones and mark the rest with zeros. Convert this number back into decimal to reveal
                        which bottle was poisoned.</p>
                  
                   
                </div>
            </div>
        </section>
        
    </div>
</article>
        </div>
    )
}

export default Puzfi
